import { CommonModule, CurrencyPipe, NgOptimizedImage } from '@angular/common';
import { HttpBackend, HttpClient, HttpParams } from '@angular/common/http';
import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CarouselModule, OwlOptions } from 'ngx-owl-carousel-o';
import { environment } from '../../../environments/environment';
import { ViewStorePopupComponent } from '../../shared/popups/view-store-popup/view-store-popup.component';
import { BrowserStorageService } from '../../shared/services/common/browser-storage.service';
import { ApiCallsService } from '../../shared/services/network/api-calls.service';
import { UserService } from '../../shared/services/user.service';
import { SafeHtmlPipe } from '../../shared/validators/safe-html.pipe';
import { desiredOrder, MAX_SIZE } from '../../utils/constants';
import { api } from '../../utils/endpoints';
import { ICONS } from '../../utils/svg-icons';
@Component({
  selector: 'app-common-xdge-store',
  imports: [CommonModule, CarouselModule, CurrencyPipe, NgOptimizedImage, SafeHtmlPipe ],
  templateUrl: './common-xdge-store.component.html',
  styleUrl: './common-xdge-store.component.scss',
})
export class CommonXdgeStoreComponent {
  @Output() xdge = new EventEmitter<number>();
  storeList: any = [];
  pagination = { limit: 4, maxSize: MAX_SIZE, skip: 0, totalItems: 0, row: 0, text: 'Loading...' };
  customOptions: OwlOptions = {
    loop: false,
    autoplay: false,
    center: false,
    dots: true,
    nav: true,
    navText: [
      '<img src="assets/images/ic_arrow_left.svg" class="arrow__icon" alt="Previous" />',
      '<img src="assets/images/ic_arrow_left.svg" class="arrow__icon right" alt="Next" />',
    ],
    autoHeight: false,
    autoWidth: true,
    responsive: {
      0: {
        items: 1,
      },
    },
  };
  @Input() public withToken: any = false;
  isInitialized = false;
  userDetails: any;
  apiUrl: string = (environment as any).apiUrl;
  desiredOrder = desiredOrder;
  ICONS = ICONS;
  formatLevel = (input: any) =>
    input
      .split('-')
      .map((word: any) => (word.toLowerCase() === 'xx' ? 'XX' : word[0].toUpperCase() + word.slice(1)))
      .join(' ');
  constructor(
    private ref: ChangeDetectorRef,
    private _apiService: ApiCallsService,
    private _storageService: BrowserStorageService,
    private _http: HttpClient,
    private _handler: HttpBackend,
    private _userService: UserService,
    private _ngbModal: NgbModal,
  ) {}

  ngOnInit(): void {
    this._userService.user.subscribe((user: any) => {
      if (user) {
        this.userDetails = user;
      }
    });
    if (this._storageService.getBrowser()) {
      if (this.withToken) {
        this.getxdgeList();
      } else {
        this.getxdgeListWithOutToken();
      }
    }
  }
  getxdgeList() {
    this._apiService.get(api._products, this._getRequest()).subscribe({
      next: (res: any) => {
        if (res) {
          this.fetch(res);
        }
      },
      error: (err: any) => {
        console.log(err);
      },
    });
  }
  getxdgeListWithOutToken() {
    this._http = new HttpClient(this._handler);
    let url = this.apiUrl + api._products;
    let request: any = { limit: this.pagination.limit };
    this._http.get<any>(url, { params: request }).subscribe((res: any) => {
      if (res) {
        this.fetch(res);
      }
    });
  }
  fetch(res: any) {
    this.pagination.row = res.data.products.edges.length;
    this.pagination.text = 'No record found!';
    this.storeList = res.data.products.edges;
    this.storeList.map((item: any, i: any) => {
      this.storeList[i].productArray = [];
      if (item.node.media.nodes?.length == 0) {
        this.storeList[i].productArray = [{ preview: '../../../../assets/images/ic_level.svg' }];
      } else {
        item.node.media.nodes.map((items: any) => {
          this.storeList[i].productArray.push({
            preview: items.preview.image.url ? items.preview.image.url : '../../../../assets/images/ic_level.svg',
          });
        });
      }
    });
    this.xdge.emit(this.storeList);
    setTimeout(() => {
      this.isInitialized = true;
      this.ref.detectChanges(); // Trigger re-render
    }, 1000);
  }
  private _getRequest(): HttpParams {
    let params: any = {};
    params['limit'] = this.pagination.limit;
    return params;
  }
  storeRedirect(data: any) {
    if (this._storageService.getWindow()) {
      window.open(data.node.onlineStorePreviewUrl, '_blank');
    }
  }
  lock(data: any) {
    if (this.userDetails) {
      let levelStatus = false;
      let level = this.userDetails.userLevel ? this.userDetails.userLevel.replace(' ', '-') : '';
      data.node.tags.map((item: any) => {
        if (item == level) {
          levelStatus = false;
        }
      });
      return levelStatus;
    } else {
      return true;
    }
  }
  onExploreClick(event: any, entity: any) {
    event.preventDefault();
    let modalRef = this._ngbModal.open(ViewStorePopupComponent, {
      scrollable: false,
      backdrop: 'static',
      keyboard: false,
      size: 'filterPopup',
      centered: true,
    });
    modalRef.componentInstance.entity = entity;
  }
  showLevel(tags: any, i: any) {
    let level = false;
    this.storeList[i].reorderedLevels = tags
      .filter((level: any) => this.desiredOrder.includes(level))
      .sort((a: any, b: any) => this.desiredOrder.indexOf(a) - this.desiredOrder.indexOf(b));
    if (this.storeList[i].reorderedLevels?.length > 0) {
      if (this.storeList[i].reorderedLevels[0] != 'no level' && this.storeList[i].reorderedLevels[0] != 'no-level') {
        level = true;
      }
    }
    return level;
  }
  removeDecimal = (num: any) => (parseInt(num.toString().replace('.', '').slice(0, -1)) / 100).toFixed(2);
}
